<template> <!--登录页面查询机构信息-->
  <div id="platformContent" >
    <!--页头开始-->
    <el-row style="height:180px; width:100%;">
      <el-col :span="24" >
        <div class="bt-head">
            <div class="bt-head-cen" style="height: 110px;">
              <div class="top_left" style="width:450px;height:120px; ">
                <a href="../">
                  <img src="~@/assets/img/logo-20180504.png" style="height: 80px;" alt="" />
                </a>
              </div>
              <div class="top_right" style="width:520px;">
                <div style="font-size: 25px;width: 31%;float: right;padding-top: 14px;">
                    管理服务平台
                </div>
                <div style="text-algin:center; color:#cd0b02; width:56%;float: right;font-size: 16px;">
                  <p style="letter-spacing: 20px; margin: 0px;">外国在华文化中心</p>
                  <p style="letter-spacing: 7px; margin: 0px;">外国旅游部门常驻代表机构</p>
                  <p style="letter-spacing: 2px; margin: 0px;">港澳台地区旅游部门常驻代表机构</p>
                </div>
              </div>
            </div>
          </div>
          <!--导航开始-->
            <div class="bt-nav-y" style="background:#9d1515">

            </div>
          <!--导航结束-->
      </el-col>
    </el-row>
    <!--页头结束-->
    <el-row type="flex" justify="center" style="height:5%; color:#5B5B5B;">
      <el-col :span="3" class="planContent-bg">
      </el-col>
      <el-col :span="19" class="planContent-bg" style="font-size:14px;">
        <div style="margin-top:4px;">&nbsp;&nbsp;<i class="el-icon-s-home"></i>当前位置：{{this.orgtitle}}信息
        </div>
      </el-col>
      <el-col :span="4" class="planContent-bg">
        <div style="margin-top:4px; cursor:pointer;">
            <span
              @click="reback()"
              :class="{mouseActive:isMouseActive}"
              @mouseenter="mouseEnter()"
              @mouseleave="mouseLeave()">[退回]</span>
        </div>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :span="18" class="planContent-bg">
        <div  style="background-color:white; width:100%; min-height:100px;">
          <el-input
            v-model="search"
            size="mini"
            placeholder="请输入机构名称"
            style="width:20%; float:right; margin-top:20px; margin-right:20px;"
            @change="searchOrg()"/>
          <el-table
            height="370"
            :data="tableData"
            style="width: 100%">
            <el-table-column
              label="机构名称"
              prop="name"
              min-width="280">
            </el-table-column>
            <el-table-column
              :label="chiefNameTitle"
              prop="chiefName"
              width="150">
            </el-table-column>
            <el-table-column
              label="设立时间"
              prop="issuedOn"
              width="120">
            </el-table-column>
            <el-table-column
              label="联系电话"
              prop="telephone"
              min-width="120">
            </el-table-column>
            <el-table-column
              label="驻在地址"
              prop="address"
              min-width="380">
            </el-table-column>
          </el-table>
          <br/>
          <el-pagination class="main-body-table-page" layout="total, sizes, prev, pager, next, jumper"
            @current-change="handleCurrentChange" @size-change="handleSizeChange"
            :current-page="pager.current" :page-size="pager.size" :total="total">
          </el-pagination>
          <br/>
        </div>
      </el-col>
    </el-row>
    <!--页脚开始-->
    <div>
     <el-row type="flex" justify="center" style="height:130px;">
       <el-col :span="24">
            <div class="bt-footer footer_box">
            <div class="footer_main">
            <div class="footer_pic">
              <a href="http://bszs.conac.cn/sitename?method=show&id=0895F7C11FF86C12E053012819AC7E96" target="_blank">
                <img src="~@/assets/img/dzjg.png" />
              </a>
            </div>
            <div class="footer_list">
             <div class="footer_nav">
               <ul>
                 <li><a href="https://www.mct.gov.cn/dbdh/gywm/" target="_blank">关于我们</a></li>
                 <li class="jg">|</li>

                 <li><a href="https://www.mct.gov.cn/dbdh/wzdt/" target="_blank">网站地图</a></li>

                 <li class="jg">|</li>
                 <li><a href="https://www.mct.gov.cn/dbdh/bqbh/" target="_blank">版权保护</a></li>

                 <li class="jg">|</li>
                 <li><a href="https://www.mct.gov.cn/dbdh/mzsm/" target="_blank">免责声明</a></li>

               </ul>
               <p>版权所有：中华人民共和国文化和旅游部 地址：东城区朝阳门北大街10号 邮编：100020</p>
               <p>ICP备案：京ICP备18030242号-1 电话：010-59881114</p>

                                   <div style="width:500px;">
                                       <p style="float:left;">网站标识码bm23000001</p>
               <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11040202440050" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;padding-left:15px;">
                 <img src="~@/assets/img/dibiao.png" style="float:left;" />
                 <span style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#cccccc;font-size:13px;">
                   京公网安备 11040202440050号
                 </span>
               </a>
             </div>
             </div>
            </div>

            <div class="footer_jc">
                <span id="_span_jiucuo">
                  <img @click="jiucuo.Link('bm23000001')"  style="margin:0;border:0;cursor: pointer;" src="https://zfwzgl.www.gov.cn/exposure/images/jiucuo.png?v=bm23000001"></span>
            </div>

            </div>
            </div>
            <!-- // <script id="_trs_ta_js" src="//ta.trs.cn/c/js/ta.js?mpid=4419" async="async" defer="defer"></script> -->
      </el-col>
     </el-row>
    </div>
    <!--页脚结束-->
  </div>

</template>


<script>
import {selectListOrg} from '../../console/api/sum/Org'
import '@/assets/base/style/login/hanweb.css'
import '@/assets/base/style/login/sy_culture.css'
import {Link} from '../../yourbiz/js/jiucuo'
export default {
  name: 'LoginOrgList',
  // 组件属性对象
  props: {
    orgListVisible:Boolean,
    orgType : String,
  },
  data() {
    return {
      // 机构查询条件
      filters: {
        type: '',
        status: 'effective',
        name:''
      },
      tableData: [], //机构数据列表
      search:'', //机构信息查询
      orgtitle:'', //标题
      isMouseActive:null, //鼠标控制
      pager: {
        current: 1,
        size: 10,
        fuzzyText: ''
      },
      total: null,
      chiefNameTitle:"首代姓名"
    }
  },
  mounted() {
    this.filters.type = this.orgType
    this.chiefNameTitle = "首代姓名"
    if(this.filters.type == 'foreigner tourism') {
      this.orgtitle = "外国旅游部门常驻代表机构"
    }else if(this.filters.type == 'HMT tourism') {
      this.orgtitle = "港澳台地区旅游部门常驻代表机构"
    }else {
      this.orgtitle = "外国在华文化中心机构"
      this.chiefNameTitle = "中心主任"
    }
    this.getOrgList(this.orgType)

  },
  methods: {
    //
    reback() {
    //  子组件向父组件绑定的属性传值
      this.$emit('update:orgListVisible', false)
      // 展示登录页面
      this.$emit('returnBack', true)
      const {href} = this.$router.resolve({
      name: "login",
      });
      this.$router.push(href);
    },
    /**
     * 主表每页记录数调整后的查询
     * @param size int 调整后的每页记录数
     */
    handleSizeChange(size) {
      this.pager.size = size;
      this.getOrgList(this.orgType);
    },
    /**
     * 主表翻页查询
     * @param current int 指定查询页号
     */
    handleCurrentChange(current) {
      this.pager.current = current;
      this.getOrgList(this.orgType);
    },
    // 机构信息查询
    getOrgList(type) {
      this.filters.type = type;
      this.filters.name = this.search;
      this.filters.current = this.pager.current;
      this.filters.size = this.pager.size
      selectListOrg(this.filters).then(response => {
        this.tableData = response.data;
        this.total = response.total;
      }).catch(err => {
        console.log(err)
      });
    },
    mouseEnter() {
       this.isMouseActive = true;
    },
    //鼠标移除事件
    mouseLeave(){
      this.isMouseActive = null;
    },
    //根据机构名称查询机构
    searchOrg() {
      this.getOrgList(this.orgType);
    }

  }
}
</script>

<style lang="scss" scoped>
.platTitleBg { //平台标题背景
  //background-color:#1D4896;
  color:white;
  text-align:center;
  padding:0px;
  height: 100%;
  background-image: url(~@/assets/img/titleBg.png);
  background-position:center;
  background-repeat:no-repeat;
  background-size:100% 100%;
  -moz-background-size:100% 100%;
}
.platTitle {
//  background-color:#1D4896;
  background-image: url(~@/assets/img/title.png);
  background-repeat:no-repeat;
  height: 100%;
  width: 100%;
}
.el-row {  //必须添加，默认el-row 为20px;
    margin-bottom: 0px;
}
.mouseActive {
  color: blue;
}
.footer_box{height:auto !important;padding-bottom:15px}
.footer_box .footer_main{width: 730px !important;}
.footer_box .footer_main .footer_pic{position: relative !important;float: left;margin: 22px 20px 0 0;left: 0;top: 0;}
.footer_box .footer_main .footer_list{float: left; margin: 15px 0 0 0;position: relative !important;left: 0;top: 0;}
.footer_jc{float: right; margin: 25px 0 0 0;}
.footer_list{width: 535px !important;}
.top_sousuo_bg{
  background-image: url(~@/assets/img/sosuo_box.jpg);
}
.top_sousuo_bg2{
  background-image: url(~@/assets/img/sosuo_s.jpg);
}

.t_chglf{float: left;font-size: 13px;color: #333333;}
.top_change{width: 1000px;margin: 0 auto;height: 35px;overflow: hidden;line-height:35px;position: relative;}
.top_right .top_link_box a{line-height:16px;}
</style>
